import React from 'react';
import cx from 'clsx';

import * as themeStyles from '../../assets/theme.module.scss';

const badgeMapping = {
    terminal: 'Dark',
    'no-minimum-order-quantity': 'Success',
    'heat-resistance-class-130-degree': 'Danger',
    'heat-resistance-class-180-degree': 'Danger',
    'heat-resistance-class-155-degree': 'Danger',
    'heat-resistance-class-200-degree': 'Danger',
    'heat-resistance-class-220-degree': 'Danger',
    'make-to-order-production': 'Primary',
    'customization-cutting': 'Secondary',
    'product-available-for-sale': 'Info',
    'production-after-ordering': 'Dark',
};

const ProductBadge = ({ type, name }) => (
    <span className={cx(themeStyles.badge, themeStyles[`badge${badgeMapping[type]}`], themeStyles.mr2)}>
        {name}
    </span>
);

export default ProductBadge;
